export default {
  cart: null,
  cartItems: [],
};
